import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { CarrierContext } from "../contexts/CarrierContext";
export default function Footer({ cms }) {
  const [scrollPosition, setScrollPosition] = useState(0);
  const baseUrl = process.env.PUBLIC_URL;
  const location = useLocation();

  // Helper function to select elements
  const select = (el, all = false) => {
    el = el.trim();
    if (all) {
      return document.querySelectorAll(el);
    } else {
      return document.querySelector(el);
    }
  };

  // Function to handle scroll event
  const onScroll = () => {
    setScrollPosition(window.scrollY); // Track scroll position
  };

  useEffect(() => {
    // Add scroll event listener when component mounts
    window.addEventListener("scroll", onScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
  const carrierContxt = useContext(CarrierContext);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : null;

  return (
    <div className="fixed-botom pb-2 exclude-in-print">
      <div className="col-12 text-center d-block footer-links-wrap">
        <ul id="footermenu">
          <a
              href={
                cms?.limited_english_proficiency_link && cms.limited_english_proficiency_link.trim() !== ""
                    ? `${cms?.limited_english_proficiency_link}`
                    : `${baseUrl}/${urlCarrier}/language_proficiency`
              }
            className="text-decoration-none"
            rel="noopener noreferrer"
          >
            <li className={location.pathname.includes("/language_proficiency") ? "active" : ""}>{cms?.limited_english_proficiency_link_name}</li>
          </a>
          <a
              href={
                cms?.non_discrimination_notice_link && cms.non_discrimination_notice_link.trim() !== ""
                    ? `${cms?.non_discrimination_notice_link}`
                    : `${baseUrl}/${urlCarrier}/language_proficiency`
              }
            className="text-decoration-none"
            target="_blank"
            rel="noopener noreferrer"
          >
            <li className={location.pathname.includes("/nondiscrimination") ? "active" : ""}>{cms?.non_discrimination_notice_link_name}</li>
          </a>
          <a
            href={`${baseUrl}/${urlCarrier}/contact_us`}
            className="text-decoration-none"
            rel="noopener noreferrer"
          >
            <li className={location.pathname.includes("/contact_us") ? "active" : ""}>{cms?.contact_us_link_name}</li>
          </a>
          <a
              href={
                cms?.faq_link && cms.faq_link.trim() !== ""
                    ? `${cms?.faq_link}`
                    : `${baseUrl}/${urlCarrier}/faq`
              }
            className="text-decoration-none"
            target="_blank"
            rel="noopener noreferrer"
          >
            <li className={location.pathname.includes("/faq") ? "active" : ""}>{cms?.faq_link_name}</li>
          </a>
          <a
            href={`${baseUrl}/${urlCarrier}/glossary`}
            className="text-decoration-none"
            rel="noopener noreferrer"
          >
            <li className={location.pathname.includes("/glossary") ? "active" : ""}>{cms?.glossary_acrn_link_name}</li>
          </a>
        </ul>
      </div>
      {/* <div className="col-12 position-relative d-xl-none d-md-none mt-3">
        <div className="align-items-center justify-content-between col-6">
          <a
            href="payment-christus.html"
            className="logo d-block align-items-center text-left"
          >
            <span className="ms-xl-4 ms-md-4 ms-sm-4 ms-2">
              <img src="assets/images/carrier-logos/BCBAZ.svg" alt="Christus" />
            </span>
          </a>
        </div>

       <div className="col-5" id="toggle-container">
          <ul id="menus">
            <a href="#" className="text-decoration-none">
              <li>Limited English Proficiency</li>
            </a>
            <a href="#" className="text-decoration-none">
              <li>Non Discrimination Notice</li>
            </a>
            <a href="Contactus-Mountain.html" className="text-decoration-none">
              <li>Contact Us</li>
            </a>
            <a href="#" className="text-decoration-none">
              <li>FAQ's</li>
            </a>
            <a href="#" className="text-decoration-none">
              <li>Glossary & Accronyms</li>
            </a>
          </ul>

          <div id="toggle">
            <div className="one"></div>
            <div className="two"></div>
            <div className="three"></div>
          </div>
        </div>
      </div>*/}
    </div>
  );
}
